import {get, post, put,Delete} from '../axios'


// 隐私协议-修改
export const privacyUpdate = params => put('/web/system/privacy/update',params);

// 隐私协议-查看
export const privacyView = params => get(`/web/system/privacy/view`);